<template>
    <div class="modal fade" id="unidade_gestora_create_modal" data-backdrop="static">
        <div class="modal demo-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <b>Novo(a)</b>
                        </h5>
                        <!-- <button type="button" class="close">
                            <span aria-hidden="true">×</span>
                        </button> -->
                    </div>
                    <div class="modal-body"> 

                        <dot :isVisible="isLoading"></dot>

                        <div v-if="!isLoading">
                            <div class="alert alert-danger" v-if="errors.length > 0">
                                <ul>
                                    <li v-for="error in errors">{{ error }}</li>
                                </ul>
                            </div>

                            <div class="form-group">
                                <label class="col-form-label">Nome:</label>
                                <input type="text" placeholder="Nome da Unidade Gestora" v-model="unidade_gestora.nome" class="form-control">
                            </div>

                            <div class="form-group">
                                <label class="col-form-label">CNPJ:</label>
                                <the-mask 
                                    class="form-control"
                                    placeholder="12.345.678/0001-99"
                                    :mask="['##.###.###/####-##']"
                                    :masked="configDateMask.maskedValue"
                                    v-model="unidade_gestora.cnpj"/>
                            </div>

                            <div class="form-group">
                                <label class="col-form-label">Endereço:</label>
                                <input type="text" placeholder="Rua XV de Maio" v-model="unidade_gestora.endereco" class="form-control">
                            </div>

                            <div class="form-group">
                                <label class="col-form-label">Resposável:</label>
                                <input type="text" placeholder="Nome do Responsável" v-model="unidade_gestora.responsavel" class="form-control">
                            </div>

                            <div class="form-group">
                                <label class="col-form-label" for="title">Município: *</label>
                                <basic-select :options="municipios"
                                        :selected-option="municipio"
                                        placeholder="Selecione o Município"
                                        @select="onSelectMunicipio">
                                </basic-select>
                            </div>

                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success"
                            @click.prevent.stop="createUnidadeGestora">
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	import { eventBus } from '../../app';
    import Dot from '../loadder/Dot.vue';
    import { TheMask } from 'vue-the-mask';
    import { BasicSelect } from 'vue-search-select';

    export default {

    	components: {
            Dot,
            TheMask,
            BasicSelect
        },


    	data(){
            return {
                configDateMask: {
                    maskedValue: false
                },
            	isLoading: false,

                //ARRAYS
            	errors: [],
                municipios: [],

                //OBJECTS
                municipio: {},
                unidade_gestora: {
                    nome: '',
                    cnpj: '',
                    endereco: '',
                    responsavel: '',
                    organizacao_id: null
                }
            }
        },

        mounted(){
        	this.registryEventOpenModalCreateUnidadeGestora();
        },

        methods: {
            registryEventOpenModalCreateUnidadeGestora(){
                eventBus.$on('eventOpenModalCreateUnidadeGestora', () => {
                	this.errors = [];
                    this.resetForm();
                    this.getOrganizacoes();
                    $("#unidade_gestora_create_modal").modal("show");
                });
            },

            emitEventGetUnidadesGestoras(){
                eventBus.$emit('eventGetUnidadesGestoras');
            },

            resetForm()
            {
                this.errors = [];
                this.municipio = {};
                this.unidade_gestora = {
                    nome: '',
                    cnpj: '',
                    endereco: '',
                    responsavel: '',
                    organizacao_id: null
                }
            },

            //OUTROS METODOS
            onSelectMunicipio(item) {
                this.municipio = item;
                this.unidade_gestora.organizacao_id = this.municipio.value;
            },
            //FIM OUTROS METODOS

            checkForm:function() {
                this.errors = [];

                if(this.unidade_gestora.nome &&
                    this.unidade_gestora.cnpj &&
                    this.unidade_gestora.endereco &&
                    this.unidade_gestora.responsavel &&
                    this.unidade_gestora.organizacao_id
                ) {
                    return true;
                }
                
                if(!this.unidade_gestora.nome) this.errors.push("Informe o nome");
                if(!this.unidade_gestora.cnpj) this.errors.push("Informe o CNPJ");
                if(!this.unidade_gestora.endereco) this.errors.push("Informe o endereço");
                if(!this.unidade_gestora.responsavel) this.errors.push("Informe o responsável");
                if(!this.unidade_gestora.organizacao_id) this.errors.push("Selecione o município");
            },

            createUnidadeGestora()
            {
                if(this.checkForm()){
                    this.isLoading = true;
                    axios.post('/unidadegestora', this.unidade_gestora).then(response => {
                        this.isLoading = false;
                        $("#unidade_gestora_create_modal").modal("hide");
                        toastr.success(response.data.message);
                        this.emitEventGetUnidadesGestoras();
                    })
                    .catch(error => {
                        let me = this;
                        this.isLoading = false;
                        let erroObject = error.response.data;
                        this.errors = [];
                        if( error.response.status === 422 ){
                            if (erroObject.errors) {
                                $.each(erroObject.errors, function (key, value) {
                                    me.errors.push(value[0]);
                                });
                            }
                        }
                        else {
                            toastr.error(erroObject.message);
                        }
                    });
                }
            },
            getOrganizacoes(){

                var urlMunicipios = '/organizacao/combo';
                
                this.isLoading = true;
                
                axios({
                    method: 'GET',
                    url: urlMunicipios
                })
                .then(response => {
                    let me = this;
                    this.isLoading = false;
                    this.municipios = [];
                    $.each(response.data, function (key, value) {
                        me.municipios.push({
                            'value': value.id,
                            'text': value.nome
                        });
                    });
                })
                .catch(error => {
                    this.isLoading = false;
                    toastr.error('Falha ao listar municípios');
                });
            },
        }
    }
</script>